import React from 'react';
import { Modal } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import CustomButton from '../Button';
import styles from './UploadFileTypeWarningModal.module.scss';

interface UploadFileTypeWarningModalProps {
  visible: boolean;
  onClose: () => void;
  disallowedTypes: string[];
  variant?: 'internal' | 'external';
}

const UploadFileTypeWarningModal: React.FC<UploadFileTypeWarningModalProps> = ({
  visible,
  onClose,
  disallowedTypes,
  variant = 'internal'
}) => {
  const typesLabel = disallowedTypes.length > 0
    ? `(${disallowedTypes.join(', ')})`
    : '';

  return (
    <Modal
      centered
      title={
        <div className={styles.modalHeader}>
          <span className={styles.modalTitle}>Upload file types</span>
          <CloseOutlined
            onClick={onClose}
            className={styles.closeIcon}
          />
        </div>
      }
      open={visible}
      onCancel={onClose}
      footer={null}
      className={`${styles.uploadFileTypeWarningModal} ${variant === 'external' ? styles.uploadFileTypeWarningModalExternal : ''}`}
      width={600}
    >
      <div className={styles.modalContent}>
        <div className={styles.content}>
          <p className={styles.mainText}>
            Your selection contains files that are not in the allowed types. These files will not be uploaded {typesLabel}.
          </p>
        </div>
        <div className={styles.actionButtons}>
          <CustomButton
            onClick={onClose}
            className={styles.confirmButton}
          >
            OK
          </CustomButton>
        </div>
      </div>
    </Modal>
  );
};

export default UploadFileTypeWarningModal;
